import moment from 'moment';
import { getBoard, getList } from '@/services/waybillDurationBoardNew';

export default {
  namespace: 'WaybillDurationBoardNew',
  state: {
    search: {
      signTime: moment()
        .add(-1, 'day')
        .format('YYYY-MM-DD'),
      productTypeName: '',
    },
    dataList: [],
    productDataList: [],
    timestamps: [],
  },
  effects: {
    *getList(_, { call, put, select }) {
      const { search } = yield select(({ WaybillDurationBoardNew }) => WaybillDurationBoardNew);
      const { signTime, productTypeName } = search;
      const { value } = productTypeName;
      const params = {
        productTypeName: (value === '定时达' && value) || undefined,
        productTimeType: ((value === '次日达' || value === '隔日达') && value) || undefined,
        advantageWaybill: (value === '是' && value) || undefined,
        startTime: moment(signTime).format('YYYY-MM-01 00:00:00'),
        signTime: moment(signTime).format('YYYY-MM-DD 23:59:59'),
      };
      const { code, data } = yield call(getList, params);
      if (code === 1) {
        const dataSource =
          (data.data || []).sort((a, b) => b.monthTicketTime - a.monthTicketTime) || [];
        yield put({
          type: 'update',
          payload: {
            dataList: dataSource,
          },
        });
      }
    },
    *getBoard(_, { put, select, call }) {
      const { search } = yield select(({ WaybillDurationBoardNew }) => WaybillDurationBoardNew);
      const { signTime, productTypeName } = search;
      const { value, alias = '全产品' } = productTypeName;
      const params = {
        productTypeName: (value === '定时达' && value) || undefined,
        productTimeType: ((value === '次日达' || value === '隔日达') && value) || undefined,
        advantageWaybill: (value === '是' && value) || undefined,
        startTime: moment(signTime).format('YYYY-MM-01 00:00:00'),
        signTime: moment(signTime).format('YYYY-MM-DD 23:59:59'),
      };
      const { code, data } = yield call(getBoard, params);
      if (code === 1) {
        const datas =
          (data.data || []).sort(
            (a, b) => moment(a.timestamp).toDate() - moment(b.timestamp).toDate(),
          ) || [];
        const timestampList = datas.map(item => moment(item.timestamp).format('YYYY-MM-DD'));
        const productDataList = datas.map(item => Number(item?.totalPeriod || 0).toFixed(1));
        yield put({
          type: 'update',
          payload: {
            timestamps: timestampList,
            productDataList: [
              {
                name: `${alias}-票均时长`,
                value: productDataList,
              },
            ],
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
